import { BTable } from "bootstrap-vue";

export default {
  name: "ClubIsActive",

  components: {
    BTable,
  },

  data() {
    return {
      disabled: false,

      url: "admin/customers_club/get_is_active",

      editUrl: "admin/customers_club/set_is_active",

      items: [],

      customers_club_is_active: false,
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.disabled = true;

      await this.$axios
        .get(this.url)
        .then((res) => {
          this.items = res.data.data.customers_club_is_active;

          this.customers_club_is_active =
            this.items.value == 1 || this.items.value === true;
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },

    async submitChanges() {
      this.disabled = true;

      await this.$axios
        .put(this.editUrl, {
          customers_club_is_active: this.customers_club_is_active,
        })
        .then((res) => {
          this.$root.notify(res.data.message, "success");
          this.loadData();
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
  },
};
